<template>
  <div>
    <b-field :label="label" class="is-relative">
      <input
        ref="placeSearchAutocomplete"
        placeholder="Enter city, postal code or address"
        class="input place-autocomplete"
        type="text"
        :value="location"
        @blur="autoFill"
      />
      <a @click="clearValue" class="clear-value-link">Clear</a>
    </b-field>
  </div>
</template>

<script>
export default {
  name: "PlaceSearch",
  props: {
    label: String,
  },
  data: function() {
    return {
      placeTypes: [
        //'geocode',
        //'establishment'
      ],
    };
  },
  mounted() {
    // // console.log('PlaceSearch', 'mounted')

    // Wait a little to allow the places code to be loaded
    setTimeout(() => {
      this.loadGoogleAutocomplete();
    }, 100);
  },
  methods: {
    loadGoogleAutocomplete() {
      this.autocomplete = new window.google.maps.places.Autocomplete(
        this.$refs.placeSearchAutocomplete,
        { types: this.placeTypes }
      );

      this.autocomplete.setFields(["geometry", "formatted_address"]);
      this.autocomplete.addListener("place_changed", this.fillInAddress);
    },
    fillInAddress() {
      const place = this.autocomplete.getPlace();
      const location = place.geometry.location;
      // // console.log(location.lat() + ', ' + location.lng())
      // // console.log(this.autocomplete.getPlace());
      var loc = {};
      loc.lat = location.lat();
      loc.lng = location.lng();
      loc.name = place.formatted_address;
      this.$emit("locUpdate", loc);
    },
    clearValue() {
      // console.log('clear input')
      this.$refs.placeSearchAutocomplete.value = "";
      var loc = {};
      this.$emit("locUpdate", loc);
    },
    autoFill(e) {
      let input = this.$refs.placeSearchAutocomplete.value;

      let vue = this;
      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        {
          address: input,
        },
        function(results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            const place = results[0];
            const location = place.geometry.location;
            var loc = {};
            loc.lat = location.lat();
            loc.lng = location.lng();
            loc.name = place.formatted_address;
            vue.$emit("locUpdate", loc);
          }
        }
      );
    },
  },
  computed: {
    newHotelLocation() {
      let location = "";

      location = this.$attrs.value.city ? this.$attrs.value.city + ", " : "";
      location += this.$attrs.value.state ? this.$attrs.value.state + ", " : "";
      location += this.$attrs.value.countryName
        ? this.$attrs.value.countryName
        : "";

      return location;
    },
    location() {
      return this.$attrs.value.name
        ? this.$attrs.value.name
        : this.newHotelLocation;
    },
  },
};
</script>

<style scoped>
.clear-value-link {
  position: absolute;
  right: 0;
  color: #ccc;
  font-size: 12px;
  line-height: 40px;
  padding: 0 15px;
}

/* *, *::after, *::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

body {
  background-color: #dcdde1;
  color: #2f3640;
  padding: 3rem;
}

.search-location {
  display: block;
  width: 60vw;
  margin: 0 auto;
  margin-top: 5vw;
  font-size: 20px;
  font-weight: 400;
  outline: none;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 10px;
} */
</style>
